import { IonRow, IonCol, IonGrid, IonIcon, IonCheckbox, IonText } from "@ionic/react";
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Origin, Anywhere } from "../../../utils/constants";
import { NewInput } from "../common/OriginInput";
import { RadiusRange } from "../RadiusRange/RadiusRange";
import PickupTime from "../../components/manage-capacity/PickupTime";

const PickupData = (props: any) => {
  const {
    originError,
    origin,
    originRadius,
    originCountry,
    originPostalCode,
    isDestination,
    defaultValue,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
    pickUpLocalTime,
    pickUpStartDate,
    pickUpEndDate,
    handleError,
    resetClick,
  } = props;
  const [updatedPickupEndDate, setUpdatedPickupEndDate] = useState("");
  useEffect(() => {
    if (props?.history?.location?.state?.searchInput) {
      setUpdatedPickupEndDate(props?.history?.location?.state?.searchInput?.pickUpEndDate);
    }
  },[]);
  const upDateLocalTime = (time: string) => {
    if (props.showDate) {
      updateLocalCurrentTime("pickUpStartDate", time);
    }
  };

  const dateChanged = (e: any) => {
    const event = { target: { name: e.target.name === 'fromDate' ? 'pickUpStartDate' : 'pickUpEndDate', value: e.target.value } };
    props.handleChange(event);
    setUpdatedPickupEndDate("");
  }

  const [checked, setChecked] = useState(true);
  useEffect(() => {
    setChecked(origin === Anywhere);
  }, [origin]);
  return (
    <IonGrid className="pickup-data">
      <IonRow>
        <IonCol size="3">
          <div className="search-heading">
            <IonIcon
              src="assets/icon/origin_icon.svg"
              className="origin-icon"
            />
            <span>Origin</span>
          </div>
        </IonCol>
        <IonCol size="8">
          <div>
            <IonText data-testid="resetBtn" onClick={() => resetClick(true, false)} className="reset-button"> Reset</IonText>
            <div className="address_field_div">
              <div className="destination-input">
                <div className="textbox-destination">
                  <NewInput
                    Error={originError}
                    labelValue=""
                    InputValue={origin}
                    InputName={Origin}
                    handleChange={(e: any) => props.handleChange(e)}
                    isDestination={isDestination}
                    deFaultValue={defaultValue}
                    locationValue={false}
                    useHandler={useHandler}
                    placeholder="Type Origin City"
                    setErrorValue={setErrorValue}
                    getLocalTime={upDateLocalTime}
                    onFocus={props.onFocus || (() => { })}
                    country={originCountry}
                    postalCode={originPostalCode}
                  />
                </div>
                <div className={`checkbox-destination ${checked ? "checked" : "not-checked"}`}>
                  <IonCheckbox
                    data-testid="destinationCheckBox"
                    checked={checked}
                    className="destinationCheckBox"
                    onClick={(e) => {
                      props.handleCheck(e);
                    }}
                    name="originCheck"
                  />{" "}
                  Anywhere
                </div>
              </div>
              <PickupTime
                pickUpLocalTime={pickUpLocalTime}
                handleChange={dateChanged}
                fromDate={pickUpStartDate}
                toDate={updatedPickupEndDate?updatedPickupEndDate:pickUpEndDate}
                error={""}
                handleError={handleError}
                rangeDisable={props.rangeOriginDisable}
              />
            </div>
          </div>
          <div className="radius-section">
            <RadiusRange
              labelName="Origin Radius"
              rangeDisabled={props.rangeOriginDisable}
              InputValue={originRadius}
              className="pickRadius"
              name={"originRadius"}
              handleChange={props.handleChange}
            />
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
export default PickupData;
